import { createAction, props } from '@ngrx/store';

import {
  ResetPasswordBody,
  TwoFactorAuthDetails,
} from '@lockton-apps/shared/interfaces';

import { AuthActionTypes } from './actions.model';

export const requireTwoFactorAuth = createAction(
  AuthActionTypes.RequireTwoFactorAuth
);

export const twoFactorAuth = createAction(
  AuthActionTypes.TwoFactorAuth,
  props<{ twoFactorDetails: TwoFactorAuthDetails }>()
);

export const resend2faCode = createAction(
  AuthActionTypes.Resend2faCode,
  props<{ email: string }>()
);

export const forgotPassword = createAction(
  AuthActionTypes.ForgotPassword,
  props<{ email: string }>()
);

export const setPassword = createAction(
  AuthActionTypes.SetPassword,
  props<{ resetPasswordBody: ResetPasswordBody }>()
);
